import { render } from "./StaffDetailsPage.vue?vue&type=template&id=d0b46f46&scoped=true"
import script from "./StaffDetailsPage.vue?vue&type=script&lang=js"
export * from "./StaffDetailsPage.vue?vue&type=script&lang=js"

import "./StaffDetailsPage.vue?vue&type=style&index=0&id=d0b46f46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0b46f46"]])

export default __exports__